import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-100 w-screen overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "px-4 py-4 sm:px-6" }
const _hoisted_4 = { class: "flex items-start justify-between" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { class: "px-4 py-5 sm:px-6 space-y-6" }
const _hoisted_9 = {
  for: "title",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_10 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-sm text-red-600 text-left",
  id: "title-error"
}
const _hoisted_12 = { class: "flex grow flex-col mr-3 text-left" }
const _hoisted_13 = { class: "flex grow flex-col mr-3 text-left" }
const _hoisted_14 = { class: "flex shrink-0 justify-end px-4 py-4 bg-gray-50" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_SwitchLabel = _resolveComponent("SwitchLabel")!
  const _component_SwitchDescription = _resolveComponent("SwitchDescription")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_SwitchGroup = _resolveComponent("SwitchGroup")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        class: "relative z-100",
        onClose: _ctx.close
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TransitionChild, {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg" }, {
                    default: _withCtx(() => [
                      _createElementVNode("form", {
                        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
                        class: "flex flex-col divide-y divide-gray-200 bg-white"
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_DialogTitle, { class: "text-base font-semibold text-gray-900" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('create_folder_modal.title')), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('folders.tip_text')), 1)
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "relative rounded-md text-gray-400 hover:text-gray-500 focus-visible:ring-2 focus-visible:ring-royal-blue-500 focus:outline-hidden",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                            }, [
                              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('create_folder_modal.close')), 1),
                              _createVNode(_component_XMarkIcon, {
                                class: "size-6",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('create_folder_modal.name')), 1),
                            _createElementVNode("div", _hoisted_10, [
                              _withDirectives(_createElementVNode("input", {
                                id: "title",
                                name: "text",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.title) = $event)),
                                type: "text",
                                autocomplete: "title",
                                class: _normalizeClass({
                                                    'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6': true,
                                                    'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('title')
                                                })
                              }, null, 2), [
                                [_vModelText, _ctx.form.title]
                              ]),
                              (_ctx.hasError('title'))
                                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                    key: 0,
                                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('title'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.getError('title')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_SwitchGroup, {
                              as: "div",
                              class: "flex items-center justify-between"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_12, [
                                  _createVNode(_component_SwitchLabel, {
                                    as: "span",
                                    class: "text-sm/6 font-medium text-gray-900",
                                    passive: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('create_folder_modal.hide_label')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_SwitchDescription, {
                                    as: "span",
                                    class: "text-sm text-gray-500"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('create_folder_modal.hide_description')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_Switch, {
                                  modelValue: _ctx.form.is_hidden,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.is_hidden) = $event)),
                                  class: _normalizeClass([_ctx.form.is_hidden ? 'bg-royal-blue-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-600 focus:ring-offset-2 focus:outline-hidden'])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      "aria-hidden": "true",
                                      class: _normalizeClass([_ctx.form.is_hidden ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'])
                                    }, null, 2)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_SwitchGroup, {
                              as: "div",
                              class: "flex items-center justify-between"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_13, [
                                  _createVNode(_component_SwitchLabel, {
                                    as: "span",
                                    class: "text-sm/6 font-medium text-gray-900",
                                    passive: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('create_folder_modal.hide_photos_label')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_SwitchDescription, {
                                    as: "span",
                                    class: "text-sm text-gray-500"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('create_folder_modal.hide_photos_description')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_Switch, {
                                  modelValue: _ctx.form.hide_photos,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.hide_photos) = $event)),
                                  class: _normalizeClass([_ctx.form.hide_photos ? 'bg-royal-blue-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-600 focus:ring-offset-2 focus:outline-hidden'])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      "aria-hidden": "true",
                                      class: _normalizeClass([_ctx.form.hide_photos ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'])
                                    }, null, 2)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "class"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                          }, _toDisplayString(_ctx.$t('create_folder_modal.cancel')), 1),
                          _createElementVNode("button", {
                            type: "submit",
                            disabled: _ctx.isCreating,
                            class: "ml-4 inline-flex justify-center rounded-md bg-royal-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-600 cursor-pointer"
                          }, _toDisplayString(_ctx.$t('create_folder_modal.create')), 9, _hoisted_15)
                        ])
                      ], 32)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["show"]))
}